import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Pensás en ciertas personas aunque no quieras y no sabés cómo soltar ese loop', 'Te acostás cansada y tu mente empieza a repasar todo lo que salió mal', 'Trabajaste el mismo patrón mil veces y sigue apareciendo', 'Sentís que cargás con emociones que no son tuyas pero no podés identificar cuáles', 'Tomás decisiones desde el miedo o la culpa sin darte cuenta', 'Fin de semana agotada, lunes volvés a empezar el mismo ciclo interno'];
  return <Section className="max-w-4xl" data-id="element-263">
      <div className="text-center mb-12" data-id="element-264">
        <h2 className="md:text-5xl font-serif font-bold mb-6 text-[28px]" data-id="element-265">
          ¿Cuánto tiempo más vas a cargar con eso?
        </h2>
        <p className="text-brand-text/80 mb-4 text-[14px]" data-id="element-266">
          Sos una mujer que trabaja su mundo interno. Que lee, que busca, que se
          esfuerza.
        </p>
        <p className="text-brand-text/80 mb-4 text-[14px]" data-id="element-267">
          Pero nadie te dijo que ibas a pasar años yendo a terapia sin que algo
          termine de cerrarse. Meditando sin que el ruido mental pare de verdad.
          Leyendo libros de autoayuda que te inspiran tres días y después todo
          vuelve igual.
        </p>
        <p className="text-xl font-medium text-brand-gold mt-6" data-id="element-268">
          No es falta de ganas. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 pt-[3px] pb-[3px] space-y-[14px]" data-id="element-269">
        <h3 className="text-xl font-medium mb-6 flex items-center text-brand-text/90" data-id="element-270">
          <X className="w-6 h-6 text-red-400 mr-2" data-id="element-271" /> Esto te resulta familiar:
        </h3>
        <ul className="space-y-4" data-id="element-272">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-273">
              <X className="w-5 h-5 text-red-400/70 mr-3 mt-0.5 shrink-0" data-id="element-274" />
              <span className="text-brand-text/80 text-[14px]" data-id="element-275">{point}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-276">
        <h3 className="text-2xl md:text-3xl font-serif font-bold gold-gradient-text" data-id="element-277">
          ¿Y si este fuera el último día que seguís igual?
        </h3>
      </div>
    </Section>;
};